import React from 'react';

export default function Checked() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#A9D342'
        fillOpacity='0.1'
      />
      <g clipPath='url(#clip0_361_8119)'>
        <path
          d='M22.6663 15.3866V16C22.6655 17.4376 22.2 18.8364 21.3392 19.9878C20.4785 21.1393 19.2685 21.9816 17.8899 22.3892C16.5113 22.7968 15.0378 22.7479 13.6893 22.2497C12.3408 21.7515 11.1894 20.8307 10.407 19.6247C9.62452 18.4186 9.25287 16.992 9.34746 15.5575C9.44205 14.123 9.99781 12.7575 10.9319 11.6647C11.8659 10.5718 13.1282 9.81021 14.5305 9.49338C15.9327 9.17656 17.3999 9.32151 18.713 9.90662M22.6663 10.6666L15.9997 17.34L13.9997 15.34'
          stroke='#A9D342'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_361_8119'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(8 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
